export const debounce = (fn, delay = 500) => {
    let timeoutId;
    return (...args) => {
        // cancel the previous timer
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        // setup a new timer
        timeoutId = setTimeout(() => {
            fn.apply(null, args)
        }, delay);
    };
};

export const getMeta = (metaName) => {
    if (metaName) {
        return document.querySelector(`meta[name=${metaName}]`).getAttribute("content");
    }

    return '';
}

export const chooseItem = e => {
    const elems = document.querySelector(".b-active");
    if(elems !== null){
        elems.classList.remove("b-active");
    }
    e.target.classList.add( "b-active");
}

export const truncateString = (text, limit) => {
    const isNeedToTruncate = text > limit;

    if (isNeedToTruncate) {
        return text.substring(0, 10) + '...';
    }

    return text;
}
